import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRequest } from '../../../helpers/apiHandler';
import SidebarCampaign from '../Sidebar';
import PageHeading from './campaignHeading';
import CampaignTables from './campaignTables';
import { reloadTopbar } from '../../../store/actions/reduxAction';

const CampaignOverview = () => {
  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.auth.user);
  const [campaignOverviewData, setCampaignOverviewData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [dateRange, setDateRange] = useState('1_day');
  const [campaignStatus, setCampaignStatus] = useState('all');
  const [statusCount, setStatusCount] = useState({
    all: 0,
    draft: 0,
    in_progress: 0,
    failed: 0,
    scheduled: 0,
    completed: 0,
    incomplete: 0,
  });
  const [reload, setReload] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const handleDate = (date) => {
    setDateRange(date);
  };

  const getCampaignOverview = useCallback((date_range, campaignStatus) => {
    setLoadingData(true);
    const payload = {
      headers: { Authorization: access_token.token },
      params: { date_range: date_range, campaign_status: campaignStatus },
    };
    getRequest('/v2/campaign-overview', payload, (res) => {
      if (res.success) {
        const { data } = res;
        setCampaignOverviewData(data.campaign_data);
        setLoadingData(false);
        setStatusCount(data.status_count);
        toggleSidebarReload();
      }
    });
  }, [access_token.token]);

  const toggleSidebarReload = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const pollInterval = 5000; // 5 seconds
    const maxPollingTime = 120000; // 2 minutes
    let pollingTimer;
    let stopPollingTimer;

    const startPolling = () => {
      getCampaignOverview(dateRange, campaignStatus);
      pollingTimer = setInterval(() => {
        getCampaignOverview(dateRange, campaignStatus);
        dispatch(reloadTopbar());
      }, pollInterval);

      stopPollingTimer = setTimeout(() => {
        clearInterval(pollingTimer);
      }, maxPollingTime);
    };

    if (dateRange === '1_day') {
      startPolling();
    } else {
      getCampaignOverview(dateRange, campaignStatus);
    }

    return () => {
      clearInterval(pollingTimer);
      clearTimeout(stopPollingTimer);
    };
  }, [dateRange, campaignStatus, getCampaignOverview]);

  useEffect(() => {
    if (reloadData) {
      getCampaignOverview(dateRange, campaignStatus);
      setReloadData(false);
    }
  }, [reloadData, dateRange, campaignStatus, getCampaignOverview]);

  const handleCampaignStatus = (status) => {
    setCampaignStatus(status);
  };

  return (
    <div className="CampaignRoute" style={{ padding: '0px' }}>
      <SidebarCampaign setStatus={handleCampaignStatus} statusCount={statusCount} reload={reload} />
      <div style={{ paddingLeft: '5px' }}>
        <PageHeading setDate={handleDate} data={campaignOverviewData} />
        <CampaignTables
          data={campaignOverviewData}
          loadingData={loadingData}
          sendReloadData={reloadData}
          setReloadData={setReloadData}
          dateRange={dateRange}
        />
      </div>
    </div>
  );
};

export default CampaignOverview;
